import orbit from './orbit';
import pan from './pan';
import zoom from './zoom';
import nodeMove from './nodeMove';
import nodeRotate from './nodeRotate';
import nodeScale from './nodeScale';
import select from './select';
import fullscreen from './fullscreen';
import home from './home';
import vrMode from './vrMode';
import firstPersonMode from './firstPersonMode';

const tools = {
  orbit,
  pan,
  zoom,
  home,
  nodeMove,
  nodeRotate,
  nodeScale,
  select,
  fullscreen,
  vrMode,
  firstPersonMode,
};

export default tools;




// WEBPACK FOOTER //
// ./src/translators/tools/index.js